import { render, staticRenderFns } from "./defaultBtn.vue?vue&type=template&id=1e0945b8"
import script from "./defaultBtn.vue?vue&type=script&lang=js"
export * from "./defaultBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports